<template>
  <div v-if="shape">
    <div v-if="shapeType === 'poi'">
      POI点ID： {{shape.id}}
    </div>
    <div v-if="shapeType === 'graphic' && shape.graphic_type === 'blockPoint'">
      块级点ID： {{shape.graphic_id}}
    </div>
    <div v-if="shapeType === 'block'">
      块ID： {{shape.name || '当前块没有配置ID，请联系设计同学'}}
    </div>
    <div v-if="shapeType === 'graphic' && shape.graphic_type !== 'blockPoint'">
      <self-generated-form
        v-if="fieldsDefinition && shape && fieldsDefinition.data[form_type]"
        v-model="currentShapeProperty"
        class="graphics__params"
        :graphic-id="shape.graphic_id"
        :fields="fieldsDefinition.data[form_type]"
        @change="onValueChanged"></self-generated-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SelfGeneratedForm from '../../../components/mapComponents/self-generated-form.vue';
import fieldsDefinition from './fields';
import request from '@/utils/request';

export default {
  components: {
    SelfGeneratedForm,
  },
  props: {
    shape: {
      type: Object,
      default: () => {},
    },
    shapeType: String,
  },
  watch: {
    shape: {
      handler(newval) {
        this.currentShapeProperty = newval ? _.cloneDeep(newval.property) : {};
      },
      deep: true,
    },
    form_type(val) {
      if (val === 'area') {
        // 区域的属性，查询一下商官后台的接口，标注的区域，在这里做一个关联
        const placeId = this.$route.query.place_id;
        request({
          url: `/label-tool-api/v2/area-query?placeId=${placeId}`,
        })
          .then((res) => {
            // eslint-disable-next-line no-return-assign
            const setChildren = item => (item.children = (item.children || []).length === 0 ? null : item.children);
            const transform = (list) => {
              list.forEach((item) => {
                setChildren(item);
                if (item.children && item.children.length) {
                  transform(item.children);
                }
              });
            };
            transform(res.data);
            this.fieldsDefinition.data.area.find(item => item.fieldName === 'area_id').props.options = res.data;
          });
      }
    },
  },
  computed: {
    form_type() {
      if (!this.shape) return null;
      if (['PanoramaPoint'].includes(this.shape.group_type)) {
        return this.shape.group_type;
      }
      if (this.shape.graphic_type === 'line') {
        return 'CommonLine';
      }
      return this.shape.graphic_type;
    },
  },
  data() {
    return {
      fieldsDefinition: null,
      currentShapeProperty: {},
    };
  },
  methods: {
    onValueChanged(e) {
      this.$emit('change', e);
    },
  },
  mounted() {
    this.currentShapeProperty = this.shape ? this.shape.property : {};
    this.fieldsDefinition = fieldsDefinition;
  },
};
</script>

<style scoped>

</style>>
